/* global __CLIENT__ */

import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import LoadingBar from 'react-redux-loading-bar';
import animateScrollTo from 'animated-scroll-to';
import { config } from '@fortawesome/fontawesome-svg-core';
import localstorage from 'store';
import A1GA from '../../../helpers/A1GA';
import SearchBox from '../../search/containers/SearchBoxContainer';
import MenuBar from '../../menuBar/MenuBar';
import HeaderBar from '../../headerBar/container/headerBarContainer';
import UpdateBar from '../../updateBar/component/updateBarComponent';
import Footer from '../../footer/containers/FooterContainer';
import AovivoBar from '../../aovivoBar/containers/AovivoBarContainer';
import routes from '../../../routes';
import ProfileModal from '../../profile/containers/ProfileModalContainer';
import CacaAoTesouroGlobalCheck from '../../cacaAoTesouroGlobalCheck/containers/CacaAoTesouroGlobalCheckContainer';
import CookieConsent from '../../../common/CookieConsent/CookieConsent';
import { checkInfoActiveHunt } from '../../cacaAoTesouro/actions/CacaAoTesouroAction';
import { getAvailableStreams } from '../../aovivoBar/actions/MediaPlayerActions';
import { getAppParameters } from '../actions/AppActions';
import SpotModal from '../../spot/containers/SpotModalContainer';
import A1Alert from '../../../common/A1Alert/A1Alert';
// FontAwesome auto-injection disabled — CSS is imported in Antena1.jsx (entry point).
// (Historically done to avoid IE issues with inline <style> injection.)
config.autoAddCss = false;

A1GA.initialize({
    debug: false, // the debug messages are too annoying. Enable if needed... // process.env.NODE_ENV !== 'production', //this is working if the ReactGA functions are used NOT the ReactGA.ga() function!
});

class AppComponent extends Component {
    static fetchData(store) {
        // we get some app wide basic parameters here. Note: This fetchData function is being called differently in the server.js file
        const myPromises = [
            store.dispatch(getAppParameters()),
            store.dispatch(checkInfoActiveHunt()),
            store.dispatch(getAvailableStreams()),
        ];

        return Promise.all(myPromises);
    }

    constructor(props) {
        super(props);

        this._checkQueryParams = this._checkQueryParams.bind(this);

        this.previousLocation = null;
    }

    componentDidMount() {
        if (this.props.jwt) {
            // fetch the users data. Note: this will also set the users isPro status and thus update gtm and show or hide banners
            this.props.getProfile();
        } else {
            // check if there is streamId saved in the local storage and set the current stream accordingly
            const streamId = localstorage.get('streamId');

            if (streamId) {
                this.props.setStream(streamId);
            }

            // send an event to tag manager to enable or disable certain tags, like vidoomy.
            window.dataLayer.push({ event: 'set_user_is_pro', user_is_pro: false });

            // set the profile to initialized, to show the banners
            this.props.setProfileInitialized();
        }

        if (this.props.params) {
            this._checkQueryParams(this.props.params);
        }

        if (this.props.location.hash) {
            this._handleHashes(true);
        }
    }

    shouldComponentUpdate(nextProps) {
        // checking here if the user isPro status changed so that the component does not have to rerender and to keep all the gtag logic in the same component
        if (nextProps.userIsPro !== null && this.props.userIsPro !== nextProps.userIsPro) {
            // send an event to tag manager to enable or disable certain tags, like vidoomy, if user is not PRO.
            window.dataLayer.push({ event: 'set_user_is_pro', user_is_pro: nextProps.userIsPro });
        }

        // Note: now loggin all changes to query and hash to analytics, for more information. If there are more pageviews now, it is because previously unlogged actions now cause pageviews...
        return this.props.location.pathname !== nextProps.location.pathname ||
            this.props.location.search !== nextProps.location.search ||
            this.props.location.hash !== nextProps.location.hash;
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.hash !== prevProps.location.hash) {
            this._handleHashes(false);
        }
    }

    _checkQueryParams = (params) => {
        // check if there are test_ query parameters and save them in the store
        const enabledTests = {};

        // eslint-disable-next-line no-unused-vars
        for (const param in params) {
            if (param.includes('test_')) {
                let value = params[param];

                if (value === 'true') {
                    value = true;
                } else if (value === 'false') {
                    value = false;
                }

                enabledTests[param] = value;
            }
        }

        if (Object.keys(enabledTests).length > 0) {
            this.props.enableTests(enabledTests);
        }

        // this.props.history.replace(this.props.history.pathname); // remove the query parameters ?!
    }

    _handleHashes(firstLoad) {
        // Intercept the default page jumping and do it smoothly

        if (this.props.location.hash) {
            setTimeout(() => {
                let delay = 1000; // so the page has time to (fully) load // TODO try to make the news blocks (and maybe other content show loading animations with the final height to avoid this delay). Once done, update the comments component as well

                if (firstLoad) {
                    // stop the default (jumping to given id)
                    window.scrollTo(0, 0);

                    delay = 3000;
                }

                const elementId = window.location.hash.split('#')[1];
                const element = document.getElementById(elementId);

                if (element) {
                    // if there is an element with this id, wait the delay and scroll to it
                    setTimeout((elementToScrollTo) => {
                        animateScrollTo(elementToScrollTo, { speed: 300, verticalOffset: -100 });
                    }, delay, element);
                }
            }, 1);
        }
    }


    render() {
        if (__CLIENT__) {
            const url = this.props.location.pathname + this.props.location.search + this.props.location.hash;

            if (this.previousLocation !== url) {
                // only log the pageview if it is really a new pageview
                A1GA.pageview(url);

                // remove utm parameters so that they are not shared in case someone shares the content
                // Note: Disabled this (currently) as it causes problems with the taboola click ids (tblci)
                // Removing the parameters caused urls like: /noticias/como-aprender-violao-sozinho-confira-5-dicas&tblci=GiDDj9IkZR3A9LTw8hUfVJ7Y2myIfOiLDvOkRcsMzZ2ZMyD3zEsogJKqkLOL8ZbsAQ
                // @TODO check if this causes any (real) problems on google analytics
                // this.previousLocation = url.replace(/(&|\?)?utm_(.*?)=[^&]+/g, '');

                this.previousLocation = url;

                // replace the url after a small timeout, to not loose the ga tracking. (no idea why this is necessary, it does not affect all users)
                // Note, this is a super ugly solution but I tried (hard) to do it differently, and even with the hitCallback the utm parameters would NOT be logged to GA. (see commented code below)
                // Note: (currently) removed. See comment above for reasoning
                // @TODO if concluded that this causes no extra/new problems, remove the commented code
                /* setTimeout(() => {
                    this.props.history.replace(this.previousLocation);
                }, 3000); */ // using 3 seconds now, testing how this will affect the stats on GA

                // Note, the following code was my latest attempt in resolving the problem of missing sessions with utm parameters. IT DID NOT WORK! no parameters were send to GA...
                // Note: if the following will be used one day, it must be implemented in the A1GA module!
                /* ReactGA.ga('send', 'pageview', url, {
                    hitCallback: this.props.history.replace(this.previousLocation)
                }); */
                // Note, the callback is fired either once send successfully or if it determines that it is not possible to send (ie if offline)
                // Not using the suggested timeout here as this is no critical code.
                // Check https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#hitCallback
            }
        }

        return (
            <div>
                <CacaAoTesouroGlobalCheck location={this.props.location.pathname} />
                <LoadingBar style={{ zIndex: 10000, position: 'fixed' }} showFastActions />
                <HeaderBar />
                <UpdateBar />
                <ProfileModal />
                <SearchBox />
                <MenuBar />
                <AovivoBar />
                <main id="main-content">
                    <Switch>
                        {routes.map((route) => (
                            <Route exact={route.exact} path={route.path} key={route.key}>
                                <route.component />
                            </Route>))}
                    </Switch>
                </main>
                <SpotModal />
                <Footer pathname={this.props.location.pathname} />
                <CookieConsent />
                <A1Alert />
            </div>
        );
    }
}

AppComponent.propTypes = exact({
    enableTests: PropTypes.func.isRequired,
    getProfile: PropTypes.func.isRequired,
    setStream: PropTypes.func.isRequired,
    setProfileInitialized: PropTypes.func.isRequired,
    jwt: PropTypes.string,
    userIsPro: PropTypes.bool,
    params: PropTypes.object,
    location: PropTypes.shape({
        pathname: PropTypes.string,
        search: PropTypes.string,
        hash: PropTypes.string,
    }),
    // Injected through withRouters but not used
    /* eslint-disable react/no-unused-prop-types */
    history: PropTypes.object,
    staticContext: PropTypes.object,
    match: PropTypes.object,
    /* eslint-enable react/no-unused-prop-types */
});

export default AppComponent;
